import { defineModuleEvidenceContract, defineModuleEvidenceEntry } from './moduleEvidenceContract';
import { DECISION_AGENT_SOURCE_CLASSES } from './sourceClasses';

// origin/main literals: apps/api/src/decision-modules/labor-arbitrage/
// labor-arbitrage.data-lake-source.ts (LABOR_ARBITRAGE_DATA_LAKE_CONTEXT_KIND,
// LABOR_ARBITRAGE_DATA_LAKE_SCHEMA_VERSION). labor-arbitrage is not an sga-spend
// lever (no 'labor_arbitrage' entry in SGA_SPEND_EVIDENCE_KEY_BY_LEVER) — a
// standalone contract, same shape as strategic-execution-capacity-diagnostic.
// Confirmed live on tenant helix_retail 2026-08-06: 4 APPROVED, ingest-anchored
// rows (3 manual-admin, latest approvedAt 2026-07-29; 1 older modeled row), all
// under this one contextKind/schemaVersion pair.
export const LABOR_ARBITRAGE_EVIDENCE_KEYS = {
  governedSnapshot: 'approved_labor_arbitrage_snapshot',
} as const;

export const LABOR_ARBITRAGE_CONTEXT_KINDS = {
  governedSnapshot: 'decision_agent:labor_arbitrage:governed_snapshot',
} as const;

export const LABOR_ARBITRAGE_SCHEMA_VERSIONS = {
  manifest: 'decision_agent_module_manifest_v1',
  governedSnapshot: 'labor_arbitrage_governed_snapshot_v1',
} as const;

const NO_LABOR_ARBITRAGE_BINDING_PLACEHOLDERS: readonly string[] = Object.freeze([]);

const laborArbitrageGovernedSnapshotEntry = defineModuleEvidenceEntry(
  LABOR_ARBITRAGE_EVIDENCE_KEYS.governedSnapshot,
  {
    // Matches both the module's own requiredEvidence[0].sourceClass declaration
    // (labor-arbitrage.manifest.ts) and the freshest live rows on helix_retail.
    sourceClass: DECISION_AGENT_SOURCE_CLASSES.manualAdmin,
    contextKind: LABOR_ARBITRAGE_CONTEXT_KINDS.governedSnapshot,
    schemaVersion: LABOR_ARBITRAGE_SCHEMA_VERSIONS.governedSnapshot,
    bindingPlaceholders: NO_LABOR_ARBITRAGE_BINDING_PLACEHOLDERS,
    domain: 'custom',
    freshnessCadence: 'monthly',
    requiredFor: ['ask_helix', 'decision_pack'],
    missingBehavior: 'block',
    description:
      'Approved labor-arbitrage governed evidence snapshot published by the governed data-lake ' +
      "source; backs every labor-arbitrage read/narration intent's requiredEvidenceKeys entry of " +
      'the same key.',
  },
);

export const LABOR_ARBITRAGE_MODULE_EVIDENCE_CONTRACT = defineModuleEvidenceContract(
  'labor-arbitrage',
  {
    governed_snapshot: laborArbitrageGovernedSnapshotEntry,
  },
  {
    evidenceKeys: Object.values(LABOR_ARBITRAGE_EVIDENCE_KEYS),
    sourceClasses: [DECISION_AGENT_SOURCE_CLASSES.manualAdmin],
    contextKinds: Object.values(LABOR_ARBITRAGE_CONTEXT_KINDS),
    schemaVersions: Object.values(LABOR_ARBITRAGE_SCHEMA_VERSIONS),
    stateKeys: Object.values(LABOR_ARBITRAGE_EVIDENCE_KEYS),
    bindingPlaceholders: NO_LABOR_ARBITRAGE_BINDING_PLACEHOLDERS,
  },
);

export type LaborArbitrageModuleEvidenceContract = typeof LABOR_ARBITRAGE_MODULE_EVIDENCE_CONTRACT;
